import React, { useState } from "react";

function HomePage() {
  const [newsletterSubmitted, setNewsletterSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-100 via-yellow-50 to-lime-50 flex items-center justify-center md:py-4 pt-[0px] pl-[16px] pr-[16px] pb-[78px]">
      <div className="max-w-3xl w-full text-center">
        {/* Logo */}
        <div className="mb-1 md:mb-4" style={{ marginTop: '-1rem' }}>
          <img
            src="https://static.lumi.new/material/a9/a98ddac5f5da58315caa1c51a6d4a5ac.jpg"
            alt="Tiny Tots Sandbox Logo"
            className="h-20 w-20 md:h-28 md:w-28 mx-auto rounded-full shadow-2xl border-4 border-white object-cover" />

        </div>

        {/* Coming Soon Title */}
        <h1 className="text-4xl md:text-6xl font-black mb-1 md:mb-3" style={{ fontFamily: "'Chalkboard SE', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
          <span className="text-sky-600">Coming</span>{" "}
          <span className="text-lime-600">Soon!</span> 🚀
        </h1>

        <p className="text-lg md:text-xl text-gray-700 mb-2 md:mb-6 font-semibold" style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
          Something magical is on its way...
        </p>

        {/* Signup Box - Moved Above the Fold */}
        <div className="bg-yellow-100 rounded-3xl border-4 border-dashed border-yellow-400 p-4 md:p-8 shadow-lg">
          <h2 className="text-xl md:text-3xl font-black text-yellow-600 mb-2 md:mb-3" style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
            Join the Sandbox Family! 🎉
          </h2>
          <p className="text-sm md:text-lg text-gray-700 mb-4 md:mb-6 font-semibold">
            Get a <span className="text-yellow-600 font-black">FREE 3-page printable coloring pack</span> instantly when you join! Plus, you'll receive our monthly newsletter with a new freebie every month and exclusive early-access alerts for our upcoming storybooks, custom apparel, and our curated boutique of nursery essentials.
          </p>
          {!newsletterSubmitted ?
          <form
            className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto"
            onSubmit={async (e) => {
              e.preventDefault();
              setError("");
              setIsSubmitting(true);
              
              const formData = new FormData(e.currentTarget);
              const email = formData.get("email") as string;
              
              try {
                const response = await fetch("https://api.lumi.new/v1/functions/p414092322000683008/addSubscriber", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify({ email })
                });
                
                const data = await response.json();
                
                if (!response.ok) {
                  throw new Error(data.error || "Failed to subscribe");
                }
                
                setNewsletterSubmitted(true);
              } catch (err: any) {
                console.error("Subscription error:", err);
                setError(err.message || "Something went wrong. Please try again.");
              } finally {
                setIsSubmitting(false);
              }
            }}>
              <input
              type="email"
              name="email"
              placeholder="Enter your email address"
              className="flex-1 px-6 py-4 rounded-full border-4 border-yellow-300 text-gray-800 text-lg font-semibold focus:outline-none focus:border-lime-500 transition-colors duration-300"
              required
              disabled={isSubmitting} />
              <button
              type="submit"
              disabled={isSubmitting}
              className="bg-lime-500 hover:bg-lime-600 text-white font-black text-lg px-8 py-4 rounded-full shadow-lg transform transition-all duration-300 hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
              style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
                {isSubmitting ? "Joining..." : "Join the Family"}
              </button>
            </form> :
          <div
            className="text-center py-4 animate-fade-in"
            style={{ animation: "fadeIn 0.6s ease-in" }}>
              <p className="text-xl md:text-2xl font-black text-lime-600 mb-3" style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
                Yay! Welcome to the Sandbox Family! 🎨
              </p>
              <p className="text-base md:text-lg text-gray-700 font-semibold">
                <a
                href="https://drive.google.com/uc?export=download&id=1gYfiHLinub4AyVF6FKIBgGqjm1t1u1QY"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sky-600 font-black underline hover:text-lime-500 transition-colors duration-300">

                  Click here to download your Free 3-Page Coloring Pack
                </a>
                . Keep an eye on your inbox for our official launch!
              </p>
            </div>
          }
          {error && (
            <p className="text-red-600 font-bold text-center mt-4">{error}</p>
          )}
        </div>
      </div>
    </div>);


}

export default HomePage;